import ModalHideContent from './ModalHideContent'

export default ModalHideContent
// eslint-disable-next-line import/export
export * from './ModalHideContent'
